import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { BRAND, errMsg } from "./constants";

const ROLE_COLOR = { owner: BRAND.orange, manager: BRAND.green, customer: "#2563EB", system: BRAND.muted };

export function ActivityPanel({ pid, authFetch, API }) {
  const [items, setItems] = useState([]);
  const [role, setRole] = useState("");
  const load = useCallback(() => authFetch({ url: `${API}/homestay/properties/${pid}/activity${role ? `?role=${role}` : ""}` })
    .then((r) => setItems(r.data.items)).catch((e) => toast.error(errMsg(e, "Could not load activity"))), [pid, authFetch, API, role]);
  useEffect(() => { load(); const t = setInterval(load, 10000); return () => clearInterval(t); }, [load]);
  return (
    <div data-testid="activity-panel" className="rounded-2xl border-2 bg-white p-4" style={{ borderColor: BRAND.line }}>
      <div className="flex items-center justify-between gap-2">
        <div className="text-sm font-bold" style={{ color: BRAND.green }}>Activity log <span className="text-xs font-normal" style={{ color: BRAND.muted }}>· live, refreshes every 10s</span></div>
        <select data-testid="activity-role-filter" className="rounded-xl border-2 px-2 py-1 text-xs" value={role} onChange={(e) => setRole(e.target.value)}>
          <option value="">Everyone</option><option value="owner">Owner</option><option value="manager">Manager</option><option value="customer">Customers</option>
        </select>
      </div>
      <div className="mt-2 max-h-[32rem] overflow-y-auto divide-y" data-testid="activity-list">
        {items.length === 0 && <div className="text-xs py-3" style={{ color: BRAND.muted }}>No activity yet.</div>}
        {items.map((a) => (
          <div key={a.id} data-testid={`activity-${a.id}`} className="py-2 text-sm flex gap-3">
            <span className="text-[10px] w-24 shrink-0" style={{ color: BRAND.muted }}>{new Date(a.created_at).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" })}</span>
            <span className="min-w-0"><b style={{ color: ROLE_COLOR[a.role] }}>{a.user_name}</b> <span className="chip text-[10px]">{a.action.replace(/_/g, " ")}</span><span className="block text-xs">{a.detail}</span></span>
          </div>
        ))}
      </div>
    </div>
  );
}
